import queryString from 'querystring';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ButtonLink from '../../components/elements/ButtonLink';
import Card from '../../components/elements/Card';
import DataTable from '../../components/elements/DataTable';
import ErrorHandler from '../../components/elements/ErrorHandler';
import Text from '../../components/fields/Text';
import SubMerchantActivationFilter from '../../components/fragments/SubMerchantActivationFilter';
import IconManagementMerchant from '../../components/icons/IconManagementMerchant';
import { AppContext } from '../../contexts';
import { useDebounce } from '../../utils/hooks';
import { getRegional } from '../../utils/storage';
import { fetchList } from './actions';
import { activationStatus } from './constants';
import styles from './styles.scoped.css';

export default function SubMerchantActivation() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { setBreadcrumbs } = useContext(AppContext);
  const [search, setSearch] = useState('');

  const userRegion = getRegional();
  const { dataDetailUser } = useSelector((state) => state.pageBase);
  const {
    dataSubMerchantActivationList: { data, meta },
    isLoadingSubMerchantActivationList,
    messageSubMerchantActivationList,
  } = useSelector((s) => s.subMerchantActivation);

  const {
    page = 1,
    size = 10,
    regional = dataDetailUser.regionalId === 'All'
      ? ''
      : dataDetailUser.regionalId,
    provinceId = dataDetailUser.provinceId === 'All'
      ? ''
      : dataDetailUser.provinceId,
    cityId = '',
    districtId = '',
    villageId = '',
    isRegisterSubPangkalan = '',
  } = queryString.parse(location.search.replace('?', ''));

  const debounceParams = useDebounce(
    page +
      size +
      regional +
      provinceId +
      cityId +
      districtId +
      villageId +
      isRegisterSubPangkalan +
      search,
    500
  );

  function getAllParams(page) {
    let allParams = {
      regional,
      page: page,
      provinceId,
      cityId,
      districtId,
      villageId,
      isRegisterSubPangkalan,
      search,
    };
    if (!userRegion) {
      allParams.regional = regional;
    }
    return allParams;
  }

  const allParams = {
    page,
    size,
    search,
    regional: regional === 'All' ? '' : regional,
    provinceId: provinceId === 'All' ? '' : provinceId,
    cityId: cityId === 'All' ? '' : cityId,
    districtId: districtId === 'All' ? '' : districtId,
    villageId: villageId === 'All' ? '' : villageId,
    isRegisterSubPangkalan:
      isRegisterSubPangkalan === 'All' ? '' : isRegisterSubPangkalan,
  };

  useEffect(() => {
    setBreadcrumbs(['Atur HET LPG 3 Kg']);
  }, []);

  useEffect(() => {
    dispatch(fetchList(allParams));
  }, [debounceParams]);

  const fetchSubMerchantList = (page) => {
    dispatch(fetchList(getAllParams(page + 1)));
  };

  const renderAction = (
    region,
    provinceId,
    cityId,
    districtId,
    villageId,
    isRegisterSubPangkalan
  ) => {
    const query = queryString.stringify({
      region,
      provinceId,
      cityId,
      districtId,
      villageId,
      isRegisterSubPangkalan,
    });
    return (
      <ButtonLink
        className={styles['btn-detail']}
        outlined
        to={location.pathname + '/set/?' + query}
      >
        <span>Ubah Status</span>
      </ButtonLink>
    );
  };

  const column = [
    { heading: 'Regional', value: 'regional' },
    { heading: 'Provinsi', value: 'provinceName' },
    { heading: 'Kota/Kab', value: 'cityName' },
    { heading: 'Kecamatan', value: 'districtName' },
    { heading: 'Kelurahan', value: 'villageName' },
    {
      heading: 'Status',
      value: ({ isRegisterSubPangkalan }) =>
        activationStatus[isRegisterSubPangkalan ? 'ACTIVE' : 'INACTIVE'],
    },
    {
      heading: 'Ubah Status',
      value: ({
        regional,
        provinceId,
        cityId,
        districtId,
        villageId,
        isRegisterSubPangkalan,
      }) =>
        renderAction(
          regional,
          provinceId,
          cityId,
          districtId,
          villageId,
          isRegisterSubPangkalan
        ),
    },
  ];

  if (messageSubMerchantActivationList) {
    return <ErrorHandler message={messageSubMerchantActivationList} />;
  }

  return (
    <>
      <SubMerchantActivationFilter />
      <Card className={styles.searchContainer}>
        <div className={styles.uploadContainer}>
          <ButtonLink
            className={styles.updatePriceBtn}
            to={'/registration-activation/set?scope=byRegional'}
            type="primary"
          >
            <IconManagementMerchant /> Aktivasi Per Wilayah
          </ButtonLink>
          <ButtonLink
            className={styles.updatePriceBtn}
            style={'red'}
            to={'/registration-activation/setting-sekaligus'}
            type={'primary'}
          >
            <img src="assets/ic-upload.svg" />
            Aktivasi Dengan File
          </ButtonLink>
        </div>
        <div className={styles['filter-wrap']}>
          <div className={styles.filters}>
            <Text
              className={styles['search-bar']}
              hideLabel
              inputProps={{
                placeholder: 'Cari data...',
                value: search,
                icon: 'ic-search.svg',
                onChange: (e) => setSearch(e.target.value),
              }}
            />
          </div>
        </div>
      </Card>
      <Card className={styles.table}>
        <div className={styles['table-container']}>
          <DataTable
            className={styles.table}
            column={column}
            data={data}
            endTreshould={200}
            loading={isLoadingSubMerchantActivationList}
            meta={meta}
            onEndReached={() => fetchSubMerchantList(meta.page)}
            onRefresh={fetchSubMerchantList}
            size={size}
            withIndex
          />
        </div>
      </Card>
    </>
  );
}
